import { patientService } from '@finpay-development/shared-platform/lib/esm/patient/services/patient-service';
import { setSelectedEncounter } from '@finpay-development/shared-platform/lib/esm/patient/state/patient-slice';
import { AppDispatch } from '../../../../../shared/state/store';

export async function syncIocFacilityAfterVobSave(
    dispatch: AppDispatch,
    patientEncounterId: number,
    facilityId: number
): Promise<{ success: boolean; errorMessage?: string }> {
    const response = await patientService.saveIOCWithPartialObject(
        { facilityId },
        patientEncounterId
    );

    if (response.hasErrors) {
        return {
            success: false,
            errorMessage: response.errorMessage || 'Failed to update IOC facility',
        };
    }

    // PUT returns a flat entity. Refresh the full encounter for encounter redux state
    const patientId = Number(response.entity?.patientId);
    if (!patientId) {
        return {
            success: false,
            errorMessage: 'IOC facility updated, but missing patientId to refresh Instance of Care',
        };
    }

    const freshResponse = await patientService.getPatientInstanceOfCare({
        patientId,
        encounterId: patientEncounterId,
    });

    if (freshResponse.hasErrors || !freshResponse.entity) {
        return {
            success: false,
            errorMessage:
                freshResponse.errorMessage ||
                'IOC facility updated, but failed to refresh Instance of Care',
        };
    }

    dispatch(setSelectedEncounter(freshResponse.entity));
    return { success: true };
}
